import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import { useExternalRowSelectionApi } from './useExternalRowSelectionApi';

export const useExternalRowSelectionClearOnFiltersChange = (filters: unknown) => {
  const { unSelectAll } = useExternalRowSelectionApi();

  const previousFilters = useRef(filters);

  useEffect(() => {
    if (isEqual(previousFilters.current, filters)) {
      return;
    }

    previousFilters.current = filters;
    unSelectAll();
  }, [filters, unSelectAll]);
};
